import { hakosaloAuth } from '..';
import IClientSession from '../interfaces/ClientSession'
import User from '../interfaces/User';
import { defineStore } from "pinia";

export const useAuthStore = defineStore('auth', {
	state: () => ({
		// session: null as null|IClientSession,
		user: null as null|User
	}),

	getters: {
		session() : IClientSession | null {
			const session = window.localStorage.getItem(hakosaloAuth.localStorageKey);
			if (session) {
				return JSON.parse(session);
			}
			return null;
		},

		isLoggedIn: (state) => (state.user != null)

		// isLoggedIn(state) : boolean {
		// 	// return this.session != null;
		// 	return this.user != null;
		// }
	}
})